type ColorPair = { light: string; dark: string; medium: string };

const colorMap = new Map<string, ColorPair>();

const hashColorKey = (key: string) => {
  let hash = 2166136261;
  for (let index = 0; index < key.length; index++) {
    hash ^= key.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) % 360;
};

/** Returns the same accessible color pair for the same teacher key. */
export const getColorPair = (teacherId?: string | number | null): ColorPair => {
  const key = String(teacherId ?? "unknown-teacher");
  const cached = colorMap.get(key);
  if (cached) return cached;

  const hue = hashColorKey(key);
  const colors = {
    light: `hsla(${hue}, 70%, 80%, 0.3)`,
    dark: `hsl(${hue}, 70%, 30%)`,
    medium: `hsla(${hue}, 70%, 65%, 0.8)`,
  };
  colorMap.set(key, colors);
  return colors;
};
